import { useState } from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { Alert, Box, InputAdornment, Stack, TextField, Typography } from '@mui/material'
import { SearchIcon } from 'components/Icons'
import MissingContactList, { studentName } from './List'
import NotifyDialog from './NotifyDialog'

const searchText = row =>
  [studentName(row), row.localId, row.parentFirstName, row.parentLastName, row.parentEmail].join(' ').toLowerCase()

export default function MissingContact() {
  const { t } = useTranslation()
  const [query, setQuery] = useState('')
  const [target, setTarget] = useState(null)

  const { list, error } = useSelector(state => state.needsAttention.missingContact)

  const words = query.trim().toLowerCase().split(/\s+/).filter(Boolean)
  const rows = list?.filter(item => words.every(word => searchText(item).includes(word)))

  return (
    <Box sx={{ pt: 2 }}>
      {error ? (
        <Alert severity="error">{t('Students without a contact could not be loaded.')}</Alert>
      ) : (
        <>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5} alignItems={{ sm: 'center' }} sx={{ mb: 2 }}>
            <TextField
              size="small"
              placeholder={t('Search student or parent')}
              value={query}
              onChange={event => setQuery(event.target.value)}
              sx={{ flex: 1, maxWidth: { sm: 360 } }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon fontSize="small" />
                  </InputAdornment>
                ),
              }}
            />
            <Typography variant="body2" color="text.secondary" sx={{ ml: { sm: 'auto' } }}>
              {t('{{count}} student(s)', { count: rows?.length ?? 0 })}
            </Typography>
          </Stack>

          <MissingContactList rows={rows} onNotify={setTarget} />
        </>
      )}

      {target && <NotifyDialog key={target.personId} target={target} rows={list ?? []} onClose={() => setTarget(null)} />}
    </Box>
  )
}
